<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        เวชระเบียน
      </h3>
      <v-row 
        class="mx-1 my-2 mt-8"
        v-if="factory_filter.length <= 0"
      >
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          xl="4"
          class="card-search pa-2"
          align-self="center"
        >
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหา"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            clearable
            color="#00A99D"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="3"
          xl="3"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            v-if="factory.length > 1"
            :items="factory"
            color="#00a99d"
            outlined
            block
            dark
            @click="dialog_template = true"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-download</v-icon>
            <span style="text-transform: capitalize">Download Template</span>
          </v-btn>
          <v-btn
            v-else
            color="#00a99d"
            outlined
            block
            dark
            href="../../files/Template medical record.xlsx"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-download</v-icon>
            <span style="text-transform: capitalize">Download Template</span>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            color="#00a99d"
            outlined
            dark
            block
            @click="dialog_excel = true"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            <span style="text-transform: capitalize">Import (excel)</span>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            color="#00a99d"
            dark
            block
            @click="addPatient()"
            class="card-search"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>ลงทะเบียนผู้ป่วย
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        class="mx-1 my-2 mt-8"
        v-else
      >
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          class="card-search-start d-flex pa-2"
          align-self="center"
        >
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหา"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            clearable
            color="#00A99D"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          class="card-search-end d-flex pa-2"
          align-self="center"
        >
        <v-autocomplete
            solo
            dense
            v-model="filter_factory"
            :items="factory_filter"
            item-text="first_name_th"
            class="card-search"
            return-object
            placeholder="ค้นหาสถานประกอบการ"
            hide-details="auto"
            color="#00A99D"
            clearable
            clear-icon="mdi-close-circle"
            item-color="teal darken-2"
            @input="search_factory()"
          >
            <template v-slot:append>
              <v-icon color="#00A99D">mdi-chevron-down</v-icon>
            </template>
        </v-autocomplete>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="3"
          xl="3"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            v-if="factory.length > 1"
            :items="factory"
            color="#00a99d"
            outlined
            block
            dark
            @click="dialog_template = true"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-download</v-icon>
            <span style="text-transform: capitalize">Download Template</span>
          </v-btn>
          <v-btn
            v-else
            color="#00a99d"
            outlined
            block
            dark
            href="../../files/Template medical record.xlsx"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-download</v-icon>
            <span style="text-transform: capitalize">Download Template</span>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            color="#00a99d"
            outlined
            dark
            block
            @click="dialog_excel = true"
            class="card-medium-download"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            <span style="text-transform: capitalize">Import (excel)</span>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="2"
          xl="2"
          align-self="center"
          class="pr-0"
        >
          <v-btn
            color="#00a99d"
            dark
            block
            @click="addPatient()"
            class="card-search"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>ลงทะเบียนผู้ป่วย
          </v-btn>
        </v-col>
      </v-row>
      <v-row  class="mx-1 mb-1 mt-5" style="font-size: 20px">
        <span class="font-16 text-333333 w-600">ผู้เข้ารับบริการ {{ total }} ราย</span>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="patientList"
        @click:row="patientOpen"
        hide-default-footer
        :loading="loadingTable"
        loading-text="กำลังโหลดข้อมูล"
      >
        <template v-slot:no-data>
          <span class="font-16">ไม่มีข้อมูล</span>
        </template>

        <template v-slot:progress>
          <v-progress-linear
            indeterminate
            height="3px"
            color="#00A99D"
            class="mx-0"
          ></v-progress-linear>
        </template>

        <template v-slot:item.no="{ item }">
          <span class="font-16">{{
            page > 1
              ? (page - 1) * 10 + patientList.indexOf(item) + 1
              : patientList.indexOf(item) + 1
          }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="font-16"
            >{{ item.account_title_th }} {{ item.first_name_th }}
            {{ item.last_name_th }}
          </span>
        </template>
        <template v-slot:item.gender="{ item }">
          <span class="font-16">{{ displayItem(item, "gender") || "-" }}</span>
        </template>
        <template v-slot:item.old="{ item }">
          <span class="font-16">{{ displayItem(item, "old") || "-" }}</span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span class="font-16">{{ displayItem(item, "phone") || "-" }}</span>
        </template>
        <template v-slot:item.company="{ item }">
          <span class="font-16">{{ item.company }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div
            class="d-flex justify-end py-2"
            v-if="item.one_id && item.one_id != null && item.one_id != ''"
          >
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click="patientOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-account-box-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
              </v-tooltip> -->
            <v-tooltip bottom v-if="!item.healthcheck_status">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="healthOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-file-document</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>ผลตรวจสุขภาพประจำปี</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dianoticOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-clipboard-text-clock-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ประวัติการรักษา</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="emrCall(item)"
                  >
                    <v-icon color="#00a99d">mdi-phone-outgoing</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>EMR Call</span>
            </v-tooltip>
            <v-tooltip v-if="biz_id !== '1349242890488778'" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                   v-if="platform !== 'lineoa'"
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="findCIDOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-qrcode</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>QR code</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dashboardEditNurseDialog(item, true)"
                  >
                    <v-icon color="#00a99d">mdi-account-box-outline</v-icon>
                  </v-btn>
                  <!-- <pre>{{item}}</pre> -->
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="homeVisit(item)"
                  >
                    <v-icon size="27" color="#00a99d">mdi-home-heart</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>นัดหมายเยี่ยมบ้าน</span>
            </v-tooltip>
          </div>
          <div class="d-flex justify-end py-2" v-else>
            <v-tooltip bottom v-if="!item.healthcheck_status">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="healthOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-file-document</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>ผลตรวจสุขภาพประจำปี</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dianoticOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-clipboard-text-clock-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ประวัติการรักษา</span>
            </v-tooltip>

            <v-tooltip v-if="biz_id !== '1349242890488778'" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                   v-if="platform !== 'lineoa'"
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="findCIDOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-qrcode</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>QR code</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dashboardEditNurseDialog(item, true)"
                  >
                    <v-icon color="#00a99d">mdi-account-box-outline</v-icon>
                  </v-btn>
                  <!-- <pre>{{item}}</pre> -->
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="homeVisit(item)"
                  >
                    <v-icon size="27" color="#00a99d">mdi-home-heart</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>นัดหมายเยี่ยมบ้าน</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dialog_excel"
        persistent
        content-class="alldialog_settings"
        max-width="600px"
      >
        <v-card class="py-5">
          <v-overlay :value="isLoading">
            <v-progress-circular 
              :size="50"
              :width="5"
              color="#00a99d"
              indeterminate></v-progress-circular>
          </v-overlay>
          <v-form ref="file" @submit.prevent="submit_form()">
            <v-card-title class="pt-2 px-6">
              <span class="pb-2 text-00a99d w-700">เพิ่มเวชระเบียน(Excel)</span>
              <v-spacer></v-spacer>
              <v-btn icon color="#00a99d" text @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-5 px-6">
              <v-col cols="12" class="py-1">
                <v-file-input
                  dense
                  v-model="files"
                  color="#00A99D"
                  counter
                  accept=".xlsx"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  :rules="rule_file"
                >
                  <template v-slot:label>
                    <span class="text-313B41 w-500 font-14">เพิ่มไฟล์</span>
                  </template>

                  <template v-slot:selection="{ text }">
                    <v-chip color="#00A99D" dark label small
                      >{{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-row class="mx-8">
                <v-spacer></v-spacer>
                <v-col cols="12" lg="auto" md="auto" sm="auto" class="pa-2">
                  <v-btn
                    color="error"
                    outlined
                    @click="close()"
                    depressed
                    block
                    class="font-16 w-500 card-medium-cancel px-8"
                    >ยกเลิก</v-btn
                  >
                </v-col>
                <v-col cols="12" lg="auto" md="auto" sm="auto" class="pa-2">
                  <v-btn
                    :disabled="is_add_file"
                    color="#00A99D"
                    type="submit"
                    depressed
                    block
                    class="font-16 w-500 card-medium px-8"
                    style="color: white"
                    >ตกลง</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_template"
        persistent
        content-class="alldialog_settings"
        max-width="600px"
      >
        <v-card class="py-5">
          <v-card-title class="pt-2 px-6">
            <span class="pb-2 text-00a99d w-700">ดาวโหลดแบบฟอร์มเวชระเบียน</span>
            <v-spacer></v-spacer>
            <v-btn icon color="#00a99d" text @click="close_template">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-5 px-6">
            <v-autocomplete
              v-model="selectedItem"
              :items="factory"
              solo
              dense
              outlined
              label="เลือกสถานประกอบการ"
              color="#00a99d"
              hide-details="auto"
              item-text="first_name_th" 
              item-value="first_name_th"
              return-object
              required
              :readonly="view"
            >
              <template slot="no-data">
                <span class="pl-2">ไม่มีข้อมูลสถานประกอบการ</span>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-row class="mx-8">
              <v-spacer></v-spacer>
              <v-col cols="12" lg="auto" md="auto" sm="auto" class="pa-2">
                <v-btn
                  color="error"
                  outlined
                  @click="close_template()"
                  depressed
                  block
                  class="font-16 w-500 card-medium-cancel px-8"
                  >ยกเลิก</v-btn
                >
              </v-col>
              <v-col cols="12" lg="auto" md="auto" sm="auto" class="pa-2">
                <v-btn
                  :disabled = "Object.keys(selectedItem).length == 0"
                  color="#00A99D"
                  depressed
                  block
                  @click="getTemplate_excel()"
                  class="font-16 w-500 card-medium px-8"
                  style="color: white"
                  >ตกลง</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="alert_dialog" scrollable persistent max-width="1000px">
        <v-card>
          <v-card-title class="justify-center">
            รายงานผลข้อผิดพลาด
          </v-card-title>
          <v-card-text style="max-height: 400px">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">เลขบัตรประชาชน/รหัสพนักงาน</th>
                    <th class="text-left">ชื่อ-สกุล</th>
                    <th class="text-left">หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in item_alert" :key="i">
                    <td>{{ item.user || "" }}</td>
                    <td>
                      {{ `${item.account_title_th || ""}${item.first_name_th || "-"} ${item.last_name_th || "-"}` }}
                    </td>
                    <td>{{ item.note }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="justify-center">
            <div class="d-flex flex-column align-center">
              <span>กรุณาเลือกไฟล์ใหม่อีกครั้ง</span>
              <div style="font-size: 14px">
                <span style="color: red">*</span
                ><span>กดดาวน์โหลดไฟล์เพื่อดาวน์โหลดรายงานผลข้อผิดพลาด</span>
              </div>
            </div>
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="#00a99d"
              style="color: white"
              @click="alert_dialog = false"
              class="card-medium"
              >ตกลง</v-btn
            >
            <v-btn
              outlined
              color="#00a99d"
              @click="downloadExcelAlert()"
              class="card-medium-cancel"
              >ดาวน์โหลดไฟล์</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Pagination :totals="total" :isPage="page" @page="changePage" />

      <!-- <HistoryCalling ref="HistoryCalling" /> -->
      <HistoryDianotic ref="HistoryDianotic" />
      <FindByCid ref="FindByCid" />

      <!-- เพิ่มรายชื่อผู้ป่วย -->
      <RegisterPatient ref="registerPatient" @addPatient="searchData" />

      <!--ข้อมูลผู้ป่วย / เเก้ไขข้อมูลผู้ป่วย -->
      <DashboardEditNurseDialog
        ref="dashboardEditNurseDialog"
        @close="searchData"
      />

      <!-- Home Visit -->
      <HomeVisitBooking ref="home" @close="searchData" />
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import { mapMutations, mapGetters } from "vuex";
import functioncryto from "@/services/encrypt.js";
import HistoryDianotic from "@/components/dialog/HistoryDianotic.vue";
import FindByCid from "@/components/dialog/FindByCid.vue";
import { Pagination } from "@/components/pagination";
import RegisterPatient from "@/components/dialog/RegisterPatient.vue";
import DashboardEditNurseDialog from "@/components/DashboardEditNurseDialog.vue";
import HomeVisitBooking from "./HomeVisit/HomeVisitBooking.vue";
import XLSX from "xlsx";

export default {
  components: {
    HistoryDianotic,
    FindByCid,
    Pagination,
    RegisterPatient,
    DashboardEditNurseDialog,
    HomeVisitBooking,
  },
  data: () => ({
    platform:"",
    loadingTable: false,
    alert_dialog: false,
    item_alert: [],
    search: "",
    editedIndex: -1,
    rule_file: [(v) => !!v || "กรุณาเลือกไฟล์ข้อมูล"],
    rule_template: [(v) => !!v || "กรุณาเลือกสถานประกอบการ"],
    dialog_excel: false,
    dialog_template: false,
    is_add_file: true,
    files: [],
    findHis: "",
    headers: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
        width: "10%",
      },
      {
        text: "ชื่อผู้รับบริการ",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "เพศ",
        align: "left",
        sortable: false,
        value: "gender",
      },
      {
        text: "อายุ",
        align: "left",
        sortable: false,
        value: "old",
      },
      {
        text: "ข้อมูลติดต่อ",
        align: "left",
        sortable: false,
        value: "phone",
      },
      {
        text: "สถานประกอบการ",
        align: "left",
        sortable: false,
        value: "company",
      },
      {
        text: "Action",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],
    patientList: [],
    total: 0,
    page: 1,
    object_id: "",
    edit: false,
    biz_id: "",
    factory:[],
    factory_filter:[],
    selectedItem:{},
    view:false,
    filter_factory:"",
    loading:true,
    isLoading:false
  }),
  async created() {
    await this.get_organize_data()
    await this.getfactory()
    await this.getfactory_filter()
    await this.searchData();
    var now_date = new Date();
    await this.getHoscode();
    this.biz_id = sessionStorage.biz_id;
    this.yearmax = now_date.getFullYear() - 7 + "-" + 12 + "-" + 31;
    this.filter_factory = { _id: "", first_name_th: "ทั้งหมด", biz_id: "all", taxid: "", type: "" }
    localStorage.setItem("isCapture", true);
  },
  sockets: {
    connect() {
      console.log("connect sockets io");
    },
    userQR(res) {
      if (res.biz_id == this.biz_id ) {
        this.searchData();
      }
    },
  },
  computed: {
    ...mapGetters(["bizId"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    search() {
      this.searchData();
    },
    files(val) {
      if (val) {
        this.is_add_file = false;
      } else {
        this.is_add_file = true;
      }
    },
    dialog_excel(val) {
      if (!val) {
        this.files = null;
        this.$refs.file.resetValidation();
      }
    },
  },
  methods: {
    homeVisit(item) {
      this.$refs.home.openDialog(item, "regis");
    },
    ...mapMutations(["setDetailConference", "setDetailPhysicalExam", "setStatusPhysicalExam"]),
    dashboardEditNurseDialog(item) {
      this.$refs.dashboardEditNurseDialog.openDialog(item);
    },
    addPatient() {
      this.$refs.registerPatient.openDialog();
    },
    openConference(item) {
      this.setDetailConference(item);
      this.$router.push({ name: "ConferenceDetail" });
    },
    async getfactory() {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/organization/getFactoryhospital?${params}`)
        // .get(`http://localhost:5000/v1/organization/getFactoryhospital?${params}`)
        .then((res)=>{
          if (res.data.result == "success"){
            this.factory = res.data.data
          }
        })
      } catch (error) {
        console.error();
      }
    },
    async getfactory_filter() {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("filter_status","true")
        await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/organization/getFactoryhospital?${params}`)
        // .get(`http://localhost:5000/v1/organization/getFactoryhospital?${params}`)
        .then((res)=>{
          if (res.data.result == "success"){
            this.factory_filter = res.data.data
            this.factory_filter.unshift({ _id:"",first_name_th: "ทั้งหมด", biz_id: "all",taxid:"",type:"" });
          }
        })
      } catch (error) {
        console.error();
      }
    },
    async getPatitentList() {
      try {
        this.loadingTable = true;
        this.patientList = [];

        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("biz_id", sessionStorage.biz_id);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/all?${params}`)
          .then((res) => {
            console.log("res", res);
            if (res.data.result == "success") {
              if (res.data.data[0].length !== 0) {
                setTimeout(() => {
                  const { data: searchData, metadata } = res.data.data[0];
                  if (metadata.length == 0) {
                    this.total = 0;
                    this.patientList = [];
                  } else {
                    const { total } = metadata[0];
                    this.total = total;
                    this.patientList = searchData;
                  }
                  this.loadingTable = false;
                }, 2000);
              }
            }
          });
      } catch (error) {
        this.loadingTable = false;
        console.error();
      }
    },
    async searchData() {
      try {
        this.loadingTable = true;
        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("biz_id", sessionStorage.biz_id);
        params.append("search", this.search || "");
        if (this.filter_factory && this.filter_factory.biz_id != "all"){
          params.append("factory", this.filter_factory.biz_id|| "");
        }
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search_record?${params}`
            // `http://localhost:5000/v1/patients/search?${params}`
          )
          .then((res) => {
            if (res.data) {
              let searchPatient = res.data.data[0].data;
              searchPatient.forEach((element) => {
                element.fullname = `${
                  element.account_title_th ? element.account_title_th : ""
                }${element.first_name_th ? element.first_name_th : ""} ${
                  element.last_name_th ? element.last_name_th : ""
                }`;
              });
              if (searchPatient.length == 0) {
                this.total = 0;
              } else {
                this.total = res.data.data[0].metadata[0].total;
              }
              this.patientList = Object.assign([], searchPatient);
              this.loadingTable = false
            }
          });
      } catch (error) {
        console.error();
      }
    },
    async emrCall(item) {
      const { one_id, account_title_th, first_name_th, last_name_th } = item;
      const params = {
        send_by :  {
            one_id: sessionStorage.oneId,
            role: sessionStorage.role_name
        },
        biz_id: sessionStorage.biz_id,
        patient_id: one_id,
        receiver_oneid: one_id,
        sender_oneid: sessionStorage.oneId,
        type_call: "EMR"
      };
      try {
        const { data: { result, data } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-conference`,
          params
        );
        if (result == "success") {
          this.setDetailConference({
            ...data,
            patient_name: `${account_title_th} ${first_name_th} ${last_name_th}`,
            // _id: data.ref_conf,
            data: data,
          });
          this.$router.push({ name: "ConferenceDetail" });
        }
      } catch (error) {
        console.error();
      }
      // this.$router.push({ name: "ConferenceDetail" });
    },
    async getTemplate_excel(){
      try {
        let params = new URLSearchParams();
        params.append("name_factory",this.selectedItem.first_name_th)
        params.append("tax_id",this.selectedItem.taxid)
        params.append("type",this.selectedItem.type)
        await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/create_templateimport?${params}`)
        .then((res)=>{
          if (res.data.result == "success"){
            this.dialog_template = false;
            this.selectedItem = {}
            // window.open(res.data.data, '_blank')
            // setTimeout(() => {
            //   window.open(res.data.data);
            // },1000);

            setTimeout(async () => {
                await this.axios.get(res.data.data, { responseType: 'blob' })
                  .then((res) => {
                    // console.log("🚀 ~ res:", res)
                    // สร้าง URL สำหรับไฟล์ที่ดาวน์โหลดมา
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Template medical record.xlsx'); // ตั้งชื่อไฟล์ที่ต้องการดาวน์โหลด
                    document.body.appendChild(link);
                    link.click();

                    // เคลีย URL และลิงก์
                    link.remove();
                    window.URL.revokeObjectURL(url);
                  })
                  .catch((err) => {
                    console.log("🚀 ~ err:", err)
                    this.$swal.fire({
                      icon: "error",
                      title: `<span style="font-size: 20px;">ดาวน์โหลดไม่สำเร็จ</span>`,
                      showConfirmButton: false,
                      timer: 2000,
                    })
                  })
              }, 1000);
          }
        })
      } catch (error) {
        console.log(error.message);
      }
    },
    healthOpen(item) {
      // console.log('item',item);
      const {
        _id,
        cid,
        one_id,
        first_name_th,
        last_name_th,
        birth_date,
        company,
        position,
        department,
        employee_id,
        age
      } = item;
      const payload = {
        one_id: one_id,
        _id: _id,
        year: moment().format("YYYY"),
        bizId: sessionStorage.biz_id,
        checkDate: moment().format("YYYY-MM-DD"),
        general: {
          general: {
            weight: "",
            height: "",
            bmi: "",
            comment: "",
            congenitalDisease: "",
            allergicHistory: "",
            smokingHistory: "",
            historyOfDrinking: "",
            bp: "",
            pulse: "",
            lastMenstrualPeriod: "",
            lastMenstrualPeriod_show: "",
            summaryBpPuls: "",
            summaryPhysical: "",
            chestXray: "",
            ekg: "",
            visionTest: "",
            waistline: "",
            visionTest_intro: ""
          },
          occupationVisionTest: {
            visionTests_R: "",
            visionTests_L: "",
            visionTests_3D: "",
            visionTestsSeparate: "",
            visionTestsEyeMuscles: "",
            visionTestsField: "",
            summaryVisiontest: ""
          },
          audioGraphy: {
            audiometry_R: [
              "",
              "",
              "",
              "",
              "",
              "",
              ""
            ],
            audiometry_L: [
              "",
              "",
              "",
              "",
              "",
              "",
              ""
            ],
            audiometry: ""
          },
          lungFunctionTest: {
            fev1_mean: "",
            fev1_predict: "",
            fev1: "",
            fvc_mean: "",
            fvc_predict: "",
            fvc: "",
            fev1fvc_mean: "",
            fev1fvc_predict: "",
            fev1_fvc: "",
            resutLungTest: "",
            lungFunctionTest: "",
            lungFunctionIntro: ""
          }
        },
        treatmentEtc: {
          other: [
            {
              checklist: "",
              results: "",
              normal: "",
              summary: ""
            }
          ],
          performance: {
            armAndHand: {
              result: "",
              summary: ""
            },
            backAndlegs: {
              result: "",
              summary: ""
            }
          },
          stoolExam: "",
          stool: {
            color: "",
            anatomy: "",
            rbc_cell: "",
            wbc_cell: "",
            parasites: "",
            stool_culture: "",
            occuolt_blood: ""
          }
        },
        bloodCount: {
          completeBloodCount: {
            hb: "",
            hct: "",
            rbc: "",
            wbc: "",
            neutrophil: "",
            lymphocyte: "",
            monocyte: "",
            eosinophi: "",
            basophil: "",
            platelet: "",
            plt_smear: "",
            mcv: "",
            mch: "",
            mchc: "",
            rbcMorphology: "",
            summaryBloodCount: ""
          }
        },
        urineResults: {
          urinalysis: {
            colors: "",
            appearance: ""
          },
          urineStrip: {
            specificGravity: {
              result: ""
            },
            ph: {
              result: ""
            },
            glucose: {
              result: ""
            },
            protein: {
              result: ""
            },
            blood: {
              result: ""
            },
            ketone: {
              result: ""
            },
            bilirubin: {
              result: ""
            },
            urobilinogen: {
              result: ""
            },
            nitrite:{
              result: ""
            },
            leukocyte: {
              result: ""
            }
          },
          urineMicroscop: {
            wbc: {
              result: ""
            },
            rbc: {
              result: ""
            },
            epithelialCell: {
              result: ""
            },
            bacteria: {
              result: ""
            }
          },
          summaryurine: ""
        },
        labResult: {
          liverFunction: {
            totalProtein: {
              result: "",
              summary: ""
            },
            albumin: {
              result: "",
              summary: ""
            },
            glubulin: {
              result: "",
              summary: ""
            },
            totalBilirubin:{
              result: "",
              summary: ""
            },
            directBilirubin: {
              result: "",
              summary: ""
            },
            sgot: {
              result: "",
              summary: ""
            },
            sgpt: {
              result: "",
              summary: ""
            },
            alkPhosphatase: {
              result: "",
              summary: ""
            },
          },
          kidneyFunction: {
            bun: {
              result: "",
              summary: ""
            },
            creatinine: {
              result: "",
              summary: ""
            }
          },
          uricAcidFunction: {
            uricAcid: {
              result: "",
              summary: ""
            }
          },
          bloodGroupDetection: {
            "bloodGroup": {
              result: "",
              summary: ""
            }
          },
          hepatitisB: {
            HBsAg: {
              result: "",
              summary: ""
            },
            antiHBs: {
              result: "",
              summary: ""
            }
          },
          hepatitisA: {
            HAV_IgM: {
              result: "",
              summary: ""
            },
            antiHAV: {
              result: "",
              summary: ""
            }
          },
          hepatitisC: {
            antiHCV: {
              result: "",
              summary: ""
            }
          },
          urine: {
            amphetamine: {
              result: "",
              summary: ""
            }
          }
        },
        laboratory: {
          bloodSugarLevel: {
              fbs: {
                result: "",
                summary: ""
              },
              HbA1C: {
                result: "",
                summary: ""
              }
          },
          bloodLipidLevel: {
              cholesterol: {
                result: "",
                summary: ""
              },
              triglyceride: {
                result: "",
                summary: ""
              },
              HDLCholesterol: {
                result: "",
                summary: ""
              },
              LDLCholesterol: {
                result: "",
                summary: ""
              }
          },
          thyroid: {
            tsh: {
              result: "",
              summary: ""
            },
            free_t4: {
              result: "",
              summary: ""
            },
            free_t3: {
              result: "",
              summary: ""
            }
          }
        },
        other_list:{
          "ipa": {
              "result": "",
              "summary": ""
          },
          "methyl_ethyl": {
              "result": "",
              "summary": ""
          },
          "cyclohexane": {
              "result": "",
              "summary": ""
          },
          "formaldehyde": {
              "result": "",
              "summary": ""
          },
          "hippuric_acid": {
              "result": "",
              "summary": ""
          },
          "acetone": {
              "result": "",
              "summary": ""
          },
          "xylene": {
              "result": "",
              "summary": ""
          },
          "benzene": {
              "result": "",
              "summary": ""
          },
          "ethanol": {
              "result": "",
              "summary": ""
          },
          "hexane": {
              "result": "",
              "summary": ""
          },
          "cyanide": {
              "result": "",
              "summary": ""
          },
          "nikel": {
              "result": "",
              "summary": ""
          },
          "ultrasound_whole_abdomen": {
              "result": "",
              "summary": ""
          },
          "ultrasound_lower_abdomen": {
              "result": "",
              "summary": ""
          },
          "ultrasound_upper_abdomen": {
              "result": "",
              "summary": ""
          },
          "ca_153": {
              "result": "",
              "summary": ""
          },
          "ca_125": {
              "result": "",
              "summary": ""
          },
          "ca_19": {
              "result": "",
              "summary": ""
          },
          "cea": {
              "result": "",
              "summary": ""
          },
          "afp": {
              "result": "",
              "summary": ""
          },
          "psa": {
              "result": "",
              "summary": ""
          },
          "calcium": {
              "result": "",
              "summary": ""
          },
          "aluminium": {
              "result": "",
              "summary": ""
          },
          "manganese": {
              "result": "",
              "summary": ""
          },
          "carboxyhemoglobin": {
              "result": "",
              "summary": ""
          },
          "lead": {
              "result": "",
              "summary": ""
          },
          "phosphorus": {
              "result": "",
              "summary": ""
          },
          "styrene": {
              "result": "",
              "summary": ""
          },
          "helicobacter_pylori": {
              "result": "",
              "summary": ""
          },
          "pap_smear": {
              "result": "",
              "summary": null
          },
          "thin_prep": {
              "result": "",
              "summary": null
          }
        },
        summary: [],
        file_id: "",
        full_name_th: `${first_name_th} ${last_name_th}`,
        full_name_eng: null,
        search_name: `${first_name_th} ${last_name_th}`,
        date: moment().format("YYYY"),
        fullname: "",
        birth_date: birth_date,
        cid: cid,
        company: company,
        position: position,
        department: department,
        employee_id: employee_id,
        patient_id: _id,
        user_import:{one_id: sessionStorage.oneId, fullname: sessionStorage.accountName},
        age:age
      };
      // const {} = item;
      // const data =
      
      this.setStatusPhysicalExam(null);
      this.setDetailPhysicalExam(payload);
      this.$router.push({ name: "PhysicalExam", query: { from: "dashboard" }  });

      // this.$router.push({ name: "PhysicalExam" });
    },
    dianoticOpen(item) {
      this.$refs.HistoryDianotic.open(item);
      // this.$router.push({ name: "PhysicalExam" });3
    },
    patientOpen($event, item_data) {
      var item = item_data.item;
      this.$refs.dashboardEditNurseDialog.openDialog(item);
    },
    // cid XXXXXXX
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    findCIDOpen(item) {
      this.$refs.FindByCid.open(item);
      // this.$router.push({ name: "PhysicalExam" });
    },
    displayItem(item, type) {
      const { account_title_th, birth_date, mobile,age,gender} = item;
      switch (type) {
        case "gender":
          if (gender) {
            return gender
          } else if (["เด็กชาย", "นาย"].includes(account_title_th)){
            return "ชาย";
          } else if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
            return "หญิง";
          break;
        case "old":
          if (birth_date || age) {
            if (birth_date){
              const y = Math.floor(
                moment.duration(moment().diff(birth_date)).asYears()
              );
              return y;
            }else{
              if (age){
                return age
              }
            }
          }
          break;
        case "phone":
          if (mobile) {
            if (mobile.length === 10) {
              return (
                mobile.slice(0, 3) +
                "-" +
                mobile.slice(3, 6) +
                "-" +
                mobile.slice(6, 10)
              );
            } else if (mobile.length === 9) {
              return (
                mobile.slice(0, 3) +
                "-" +
                mobile.slice(3, 6) +
                "-" +
                mobile.slice(6, 9)
              );
            } else {
              return mobile;
            }
          }
          break;
      }
    },
    search_factory () {
      this.page = 1
      this.searchData();
    },
    changePage(e) {
      this.page = e;
      this.searchData();
    },
    close() {
      this.dialog_excel = false;
      this.files = null;
      this.$refs.file.resetValidation();
    },
    close_template() {
      this.dialog_template = false;
      this.selectedItem = {}
    },
    async getHoscode() {
      try {
        const { data: { data } = {} } = await this.axios.get(
          `https://qr-tele.manageai.co.th/api/v1/bizid/hospital/getall?is_deleted=0`,
          {
            headers: {
              Authorization:
                "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MzUzNzE4NzEsImlhdCI6MTcwNDI2Nzg3MSwibmJmIjoxNzA0MjY3ODcxLCJyZWYiOjAsInN1YiI6ImQ4ZDZjZDlhLWNmZjktNDI4Yi05NGFlLWY1ZGZiMWU2OTRkNiJ9.dAsuJepoiD703rSIlV0LeJzoMerdNfuShq3ZFFXX1auJWtWZsAZ80vgG6oP5qdix3n90lHoxn-TzrK4l-7qWpg",
            },
          }
        );
        const ov_code = data.find(
          (element) => element.business_id == sessionStorage.biz_id
        );
        if (ov_code) {
          this.findHis = ov_code.hospital_code;
        } else {
          this.findHis = "";
        }
        // console.log("🚀 ~ file: Dashboard.vue:1193 ~ getHoscode ~ data:",data.find(
        //   (element) => element.business_id == sessionStorage.biz_id
        // ));
      } catch (error) {
        console.error();
      }
    },
    async submit_form() {
      try {
        let form_data = new FormData();
        let file = this.files;
        // console.log(this.files);
        form_data.append("medical_record", file);
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        this.isLoading = true
        // console.log(form_data);
        await this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/importExcelMedicalRecord?biz_id=${sessionStorage.biz_id}&hoscode=${this.findHis}&user_create=${sessionStorage.account_id}`,
            form_data,
            config
          )
          .then(async (res) => {
            // console.log(res);
            if (res.data.result === "success" && res.data.data.length === 0) {
              this.isLoading = false
              this.$swal.fire({
                icon: "success",
                title: "บันทึกข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.close();
              await this.searchData();
            } else if (
              res.data.result === "success" &&
              res.data.data.length > 0
            ) {
              this.isLoading = false
              this.item_alert = res.data.data;
              this.alert_dialog = true;
              this.close();
              await this.searchData();
            } else {
              this.$swal.fire({
                icon: "error",
                title: `<span style="font-size: 24px;">ผิดพลาด</span> \n <span style="font-size: 18px;">กรุณาลองใหม่อีกครั้ง</span>`,
                showConfirmButton: false,
                timer: 3000,
              })
            }
            this.files = null;
            this.$refs.file.resetValidation();
          }).catch(async(err) => {
            if (err.response.data.data && err.response.data.data.length > 0) {
              this.item_alert = err.response.data.data;
              this.alert_dialog = true;
            } else if (err.response.data.message && err.response.data.message == "No data found in file") {
              this.$swal.fire({
                icon: "error",
                title: `<span style="font-size: 20px;">บันทึกข้อมูลไม่สำเร็จ</span>`,
                showConfirmButton: false,
                timer: 3000,
              })
            } else {
              this.$swal.fire({
                icon: "error",
                title: `<span style="font-size: 24px;">ผิดพลาด</span> \n <span style="font-size: 18px;">กรุณาลองใหม่อีกครั้ง</span>`,
                showConfirmButton: false,
                timer: 3000,
              })
            }
            this.isLoading = false
            this.close();
            await this.searchData();
            this.files = null;
            this.$refs.file.resetValidation();
          });
      } catch (err) {
        this.isLoading = false
        this.$swal.fire({
          icon: "error",
          title: `<span style="font-size: 20px;">บันทึกข้อมูลไม่สำเร็จ</span>`,
          showConfirmButton: false,
          timer: 3000,
        })
        console.log(err);
      }
    },
    downloadExcelAlert() {
      let header = [
        {
          key1: "เลขบัตรประชาชน",
          key2: "คำนำหน้าไทย",
          key3: "ชื่อไทย",
          key4: "นามสกุลไทย",
          key5: "หมายเหตุ",
        },
      ];
      var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 30 },
        { width: 30 },
        { width: 40 },
      ];
      const dataWS = XLSX.utils.json_to_sheet(header, {
        skipHeader: true,
        origin: "A1",
      });
      XLSX.utils.sheet_add_json(dataWS, this.item_alert, {
        skipHeader: true,
        origin: "A2",
      });
      dataWS["!cols"] = wscols;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(
        wb,
        `report ${moment().add(543, "year").format("DD_MM_YYYY")}.xlsx`
      );
    },
    async get_organize_data() {
      try {
        let params = new URLSearchParams();
        params.append("biz_id", sessionStorage.getItem("biz_id"));
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/organization/getOrganizationByBizId?${params}`,
          )
          .then((res) => {
            this.platform = res.data.data.platform;
            console.log("🚀 ~ .then ~ this.platform:", this.platform)
          })
          .catch((err) => {
            console.log("axios get_organize_data err:", err.message);
          });
      } catch (error) {
        console.log("function get_organize_data error:", error.message);
      }
    },
  },
};
</script>
<style scoped>
::v-deep .v-btn--is-elevated {
  box-shadow: 0px 0px 0px 0px !important;
}
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

::v-deep .v-input input {
  line-height: 1.8rem;
  text-indent: 4px;
}
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
